import { Loader } from '@devd-client/devd/components';
import React, { Suspense } from 'react';

const GmeetInstallation = React.memo(
  React.lazy(() =>
    import('@devd-client/devd/ui-shared').then((module) => ({
      default: module.Gmeet,
    }))
  )
);

export function AsyncGmeetInstallation() {
  return (
    <Suspense fallback={<Loader />}>
      <GmeetInstallation />
    </Suspense>
  );
}
